import { createAsyncThunk } from '@reduxjs/toolkit';
import { CallLogAPI } from '../../helpers/firebase_helper';

// Thunk 1: Request pre-signed URL from backend
export const requestPresignedUrl = createAsyncThunk(
  'callLog/requestPresignedUrl',
  async ({ fileName, fileType, fileSize }, { rejectWithValue }) => {
    try {
      const result = await CallLogAPI.requestPresignedUrl(
        fileName,
        fileType,
        fileSize
      );
      return result;
    } catch (error) {
      console.log(error);
      
      return rejectWithValue(
        error.response?.data?.message || 'Failed to get upload URL'
      );
    }
  }
);

// Thunk 2: Upload file to S3 using pre-signed URL
export const uploadFileToS3 = createAsyncThunk(
  'callLog/uploadFileToS3',
  async ({ file, preSignedUrl }, { rejectWithValue, dispatch }) => {
    try {
      const result = await CallLogAPI.uploadToS3(
        preSignedUrl,
        file,
        (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          dispatch({ type: 'callLog/uploadProgress', payload: progress });
        }
      );
      return result;
    } catch (error) {
      console.log(error);
      
      return rejectWithValue(
        error.response?.data?.message || 'Failed to upload file to S3'
      );
    }
  }
);

// Thunk 3: Fetch call log summary
export const fetchCallLogSummary = createAsyncThunk(
  'callLog/fetchCallLogSummary',
  async ({ correlationId }, { rejectWithValue }) => {
    try {
      const result = await CallLogAPI.fetchCallLogSummary(correlationId);
      return result;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch call log summary'
      );
    }
  }
);

// Thunk 4: Fetch all uploaded call logs
export const fetchUploadedCallLogs = createAsyncThunk(
  'callLog/fetchUploadedCallLogs',
  async ({ itemsPerPage, offset }, { rejectWithValue }) => {
    try {
      const callLogs = await CallLogAPI.getAllCallLogs(itemsPerPage, offset);
      return callLogs;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch uploaded call logs'
      );
    }
  }
);

// Thunk 5: Delete call log
export const deleteCallLog = createAsyncThunk(
  'callLog/deleteCallLog',
  async ({ callLogId }, { rejectWithValue }) => {
    try {
      const result = await CallLogAPI.deleteCallLog(callLogId);
      return result;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to delete call log'
      );
    }
  }
);

// Thunk 6: Download call log
export const downloadCallLog = createAsyncThunk(
  'callLog/downloadCallLog',
  async ({ callLogId, fileName }, { rejectWithValue }) => {
    try {
      const blob = await CallLogAPI.downloadCallLog(callLogId);
      
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return { callLogId };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to download call log'
      );
    }
  }
);

// Thunk 7: Get download URL (alternative approach)
export const getDownloadUrl = createAsyncThunk(
  'callLog/getDownloadUrl',
  async ({ callLogId }, { rejectWithValue }) => {
    try {
      const downloadUrl = await CallLogAPI.getDownloadUrl(callLogId);
      return { callLogId, downloadUrl };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to get download URL'
      );
    }
  }
);
